// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2x-Mm","label":"Category_label__1NHrr","content":"Category_content__2lhn9","header":"Category_header__2KuO1","location":"Category_location__3CWVi"};